import { createAppSlice } from '../../app/createAppSlice'
import { fetchMediaLibrary, updateMediaLibrary } from './mediaAPI'
import { createEntityAdapter, isAnyOf } from '@reduxjs/toolkit'
import { startAppListening } from '../../app/listenerMiddleware'

//entity: { id: "sequential", label: "", title: "", date: "YYYY-MM-DD", dateDisplay: "", year: "", type: "", url: "", iFrame: "" }
//key uses: to provide annotated links to articles, presentations, and other external marketing-value mentions of CP, FEvIR, HEvKA, etc.

const mediaAdapter = createEntityAdapter({
    sortComparer: (a, b) => {
        if (b?.date && a?.date) {
            return b.date.localeCompare(a.date)
        } else if (b?.dateDisplay && a?.dateDisplay) {
            return b.dateDisplay.localeCompare(a.dateDisplay)
        } else {
            return true
        }
    }
})

const initialState = mediaAdapter.getInitialState({
    status: 'idle',
    error: null
})

const mediaSlice = createAppSlice({
    name: "media",
    initialState,
    reducers: create => ({
        mediaAdded: create.preparedReducer(
            (mediaBody) => {
                return {
                    payload: {
                        id: mediaBody.id, label: mediaBody.label, date: mediaBody.date, 
                        dateDisplay: mediaBody.dateDisplay,
                        year: mediaBody.year, type: mediaBody.type, title: mediaBody.title, url: mediaBody.url,
                        user: mediaBody.user, iFrame: ""
                    }
                }
            },
            mediaAdapter.addOne
        ),
        mediaUpdated: create.reducer((state, action) => {
            const { id, label, date, dateDisplay, year, type, title, url, iFrame } = action.payload;
            mediaAdapter.updateOne(state, { id, changes: { label, date, dateDisplay, year, type, title, url, iFrame } })
        }),
        fetchMediaItems: create.asyncThunk(
            async () => {
                const response = await fetchMediaLibrary()
                return response.data
            },
            {
                options: {
                    condition(arg, thunkApi) {
                        const { media } = thunkApi.getState()
                        if (media.status !== 'idle') {
                            return false
                        }
                    }
                },
                pending: state => {
                    state.status = "loading"
                },
                fulfilled: (state, action) => {
                    state.status = "succeeded"
                    mediaAdapter.setAll(state, action.payload)
                },
                rejected: (state, action) => {
                    state.status = "failed"
                    state.error = action.error.message ?? "Unknown Error"
                },
            },
        ),
    }),
    selectors: {
        selectMediaStatus: media => media.status,
        selectMediaError: media => media.error
    },
})

export const { mediaAdded, mediaUpdated, fetchMediaItems } = mediaSlice.actions

export const { selectMediaStatus, selectMediaError } = mediaSlice.selectors

export const {
    selectAll: selectAllMedia,
    selectById: selectMediaById,
} = mediaAdapter.getSelectors(state => state.media)

export const addMediaListeners = () => {

    startAppListening({
        matcher: isAnyOf(mediaAdded, mediaUpdated),
        effect: async (action, listenerApi) => {
            console.log("media listener was triggered")
            try {
                const newMediaLibrary = selectAllMedia(listenerApi.getState());
                let response = await updateMediaLibrary(newMediaLibrary);
                if (response?.data) {
                    alert("update successful")
                } else {
                    alert("FAILED")
                }
            } catch (err) {
                console.log("FAILURE of updateMediaLibrary: ", err)
            }
        }
    })
}

export default mediaSlice